<template>
  
  <v-container fluid>

    <buy-now-dialog
      @on-close="buyNowDialog = false"
      @on-purchase="buyNowCompleted"
      :open="buyNowDialog"
      :trip="buyNowTrip"
      :preselect="buyNowSelection"
    ></buy-now-dialog>

    <!--<v-dialog
      v-model="buyDialog"
      max-width="800"
      scrollable
      transition="fade"
      :persistent="buying"
    >
      <v-card color="white">
        
        <v-card-title class="primary white--text text-xs-center" style="position: relative;">
          <v-btn
            absolute
            small
            fab
            top
            right
            flat
            color="white"
            style="top: 10px;"
            @click="buyDialog = false"
          ><v-icon>fas fa-times</v-icon></v-btn>
          <h3 style="margin: 0 auto;">Checkout</h3>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-layout row wrap>
            <v-flex sm6 class="grey lighten-4 pa-3">
              <inventory-item
                v-if="buyInventory._id"
                :item="buyInventory"
                buy-now-summary
              />
            </v-flex>
            <v-flex sm6 class="pa-3">
              <v-layout row wrap>
                <v-flex xs12 v-if="userHasSavedCard" class="text-xs-center">
                  Amount will be charged to your
                  <div class="pa-3 my-3 grey lighten-3">
                    <h4>{{ user.cc_brand }} ending in {{ user.cc_last4 }}</h4>
                  </div>
                </v-flex>
                <v-flex xs12 :class="{'d-none': (userHasSavedCard)}">
                  <h3>Billing Address</h3>
                  <v-container grid-list-md class="pa-0 ma-0">
                    <v-layout row wrap class="mt-3">
                      <v-flex xs12>
                        <div class="field-label">Street</div>
                        <v-text-field
                          flat
                          solo
                          hide-details
                          class="pt-0"
                          v-model="billing_street"
                          :disabled="buying"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <div class="field-label">City</div>
                        <v-text-field
                          flat
                          solo
                          hide-details
                          class="pt-0"
                          v-model="billing_city"
                          :disabled="buying"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs3>
                        <div class="field-label">State</div>
                        <v-text-field
                          flat
                          solo
                          hide-details
                          class="pt-0"
                          v-model="billing_state"
                          :disabled="buying"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs3>
                        <div class="field-label">Zip</div>
                        <v-text-field
                          flat
                          solo
                          hide-details
                          class="pt-0"
                          v-model="billing_zip"
                          :disabled="buying"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <div class="field-label">Country</div>
                        <country-select
                          :prefill="billing_country"
                          @on-change="updateCountry"
                          :disabled="buying"
                        ></country-select>
                        
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <h3 class="mt-4">Card Information</h3>
                  <v-container grid-list-md class="pa-0 ma-0">
                    <v-layout row class="mt-2">
                      <v-flex>
                        <stripe
                          ref="stripe"
                          @on-change="stripeChange"
                          @on-error="processNewStripeError"
                          @on-token="processNewStripeToken"
                        ></stripe>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  
                </v-flex>
              </v-layout>
              <div class="text-xs-center">
                <v-btn color="primary" :disabled="checkoutConfirmDisabled" @click="preProcessOrder" :loading="buying">
                  BUY NOW
                </v-btn>
              </div>
              <div class="text-xs-center mt-2" v-if="userHasSavedCard">
                <a class="grey--text text--darken-2 caption" @click="userHasSavedCard = false">CHANGE CARD</a>
              </div>
              <div class="text-xs-center mt-2" v-else-if="user.cc_brand">
                <a class="grey--text text--darken-2 caption" @click="userHasSavedCard = true">USE {{ user.cc_brand.toUpperCase() }} XXXX-{{ user.cc_last4 }}</a>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="primary white--text">
          <v-spacer></v-spacer>
          
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>-->

    <!--<v-dialog
      v-model="buyThankYouDialog"
      max-width="600"
      scrollable
      transition="fade"
    >
      <v-card color="white">
        
        <v-card-title class="primary white--text text-xs-center" style="position: relative;">
          <v-btn
            absolute
            small
            fab
            top
            right
            flat
            color="white"
            style="top: 10px;"
            @click="buyThankYouDialog = false"
          ><v-icon>fas fa-times</v-icon></v-btn>
          <h3 style="margin: 0 auto;">Purchase Confirmation</h3>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-layout row wrap>
            <v-flex xs12 class="pa-3 text-xs-center">
              <h4>Thank you for your purchase!</h4>
              <v-layout row class="mt-3">
                <v-flex>
                  <table cellspacing="0px" class="order-details-table">
                    <thead>
                      <tr>
                        <th>Order Date</th>
                        <th>Payment Method</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {{ $moment(buyOrder.create_date).format("L") }}
                        </td>
                        <td>{{ buyOrder.cc_brand }} XXXX-{{ buyOrder.cc_last4 }}</td>
                        <td>${{ buyOrder.total_price }}</td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="primary white--text"></v-card-actions>
      </v-card>
    </v-dialog>-->

    <v-layout row my-1 v-if="trips.length > 0">
      <v-flex xs12 class="text-xs-center">
        <h3>My Trips</h3>
      </v-flex>
    </v-layout>

    <transition name="fade-up" mode="out-in">
      <v-layout row v-if="loading" key="trips-loading">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </v-layout>
      <v-layout row v-else-if="trips.length <= 0" wrap key="trips-none">
        <!--<v-flex xs12 my-1 class="text-xs-center">
          <span class="body-1">You don't have any trips. </span><router-link :to="{name: 'trip',params:{id:'new'}}">Get Started</router-link>
        </v-flex>-->
        <v-flex xs12 my-5>
          <v-layout row justify-center align-center>
            <v-flex pa-3 style="max-width: 700px; border: 2px solid #000">
              <v-layout row justify-center align-center style="min-height: 250px;">
                <v-flex class="text-xs-center">
                  <div class="my-4"><h3 class="ma-0">Style me for my next trip</h3></div>
                  <div class="body-1 my-4"><div style="max-width: 340px; margin: 0 auto;">Where are you traveling next?<br>Get started with TRVL Porter to see what styles could be waiting at your destination.</div></div>
                  <div class="my-4"><v-btn dark color="black" :to="{name: 'trip', params:{id:'new'}}">Get Started</v-btn></div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout column my-5 v-else>
        <v-flex>

          <v-layout row wrap v-if="currentTrips.length" class="mb-4">
            <v-flex xs12 class="text-xs-center mb-2">
              <h4>Current</h4>
            </v-flex>
            <trip-summary
              v-for="(trip, tripIndex) in currentTrips"
              :key="'trip-' + tripIndex"
              :trip="trip"
              current
              @on-buy-now="openBuyNow"
              @on-owned="openOwned"
            ></trip-summary>
          </v-layout>

          <v-layout row wrap v-if="upcomingTrips.length" class="mb-4">
            <v-flex xs12 class="text-xs-center mb-2">
              <h4>Upcoming</h4>
            </v-flex>
            <trip-summary
              v-for="(trip, tripIndex) in upcomingTrips"
              :key="'trip-' + tripIndex"
              :trip="trip"
              @on-cancelled="removeTrip"
              @on-owned="openOwned"
            ></trip-summary>
          </v-layout>

          <v-layout row wrap v-if="recentTrips.length" class="mb-4">
            <v-flex xs12 class="text-xs-center mb-2">
              <h4>Recent</h4>
            </v-flex>
            <trip-summary
              v-for="(trip, tripIndex) in recentTrips"
              :key="'trip-' + tripIndex"
              :trip="trip"
              @on-buy-now="openBuyNow"
              @on-owned="openOwned"
            ></trip-summary>
          </v-layout>

          <v-layout row wrap v-if="pastTrips.length" class="mb-4">
            <v-flex xs12 class="text-xs-center mb-2">
              <h4>Past</h4>
            </v-flex>
            <trip-summary
              v-for="(trip, tripIndex) in pastTrips"
              :key="'trip-' + tripIndex"
              :trip="trip"
              @on-buy-now="openBuyNow"
              @on-owned="openOwned"
            ></trip-summary>
          </v-layout>

          <v-layout row wrap v-if="tripsNextPage > 1" justify-center>
            <v-flex class="text-xs-center">
              <v-btn color="primary" :loading="tripsLoadingMore" @click="getDataFromApi();">Load More</v-btn>
            </v-flex>
          </v-layout>
        <!--<v-flex 
          xs12 
          style="border: 2px solid #000;" 
          pa-0
          my-2
          class="text-xs-left" 
          v-for="(trip, tripIndex) in trips"
          :key="'trip-' + tripIndex"
        >
          <v-layout>
            <v-flex v-if="trip.lookbook">

              <v-layout row pa-0 ma-0 align-center fill-height style="position: relative;">

                <div style="position: absolute; top: 0px; bottom: 0px; left: 0px; width: 110px; z-index: 0;" class="primary"></div>

                <v-flex style="min-width: 110px; z-index: 1;" class="white--text text-xs-center" shrink>
                 
                  <h2 class="ma-0 pa-0">{{ $moment(trip.checkin_date).format("DD") }}</h2>
                  <div>{{ $moment(trip.checkin_date).format("MMM YYYY") }}</div>
                      
                </v-flex>
               
                <v-flex class="text-xs-left ma-0 pa-0" style="position: relative;">
                  <div style="position: absolute; top: 0px; left: 0px; right: 0px;" class="px-3 py-2">
                    <strong>{{trip.location_city}}, {{trip.location_state}}</strong>
                  </div>

                  <v-layout :row="$vuetify.breakpoint.mdAndUp" :column="$vuetify.breakpoint.smAndDown" fill-height align-center>
                    <v-flex pa-3 :mt-2="$vuetify.breakpoint.mdAndUp" :mt-3="$vuetify.breakpoint.smAndDown" :style="{'width':($vuetify.breakpoint.smAndDown ? '100%' : 'auto')}">
                      <span style="font-size: 1.2em;" class="mt-3">{{ tripSummary(trip).title }}</span>
                    </v-flex>
                    <v-flex style="min-width: 140px; max-width: 140px;" class="text-xs-center pa-2" shrink>
                      <v-btn small block color="primary" :to="{name: 'trip', params: {id: trip._id}}">{{ tripSummary(trip).button }}</v-btn>
                      <a style="text-decoration: none;" @click="confirmCancelTrip(trip)">Cancel Trip</a>
                    </v-flex>
                  </v-layout>
                </v-flex>
                
              </v-layout>

            </v-flex>
            <v-flex v-else>
              <div class="spinner my-0">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>-->
        </v-flex>
      </v-layout>
    </transition>
    

  </v-container>

</template>

<script>
import BuyNowDialog from '@/components/helpers/BuyNowDialog';
import TripSummary from '@/components/helpers/TripSummary';
import InventoryItem from '@/components/helpers/InventoryItem';
import Stripe from '@/components/helpers/Stripe';
import CountrySelect from '@/components/helpers/CountrySelect';

export default {
  name: 'AccountTripHistory',
  components: {
    'buy-now-dialog': BuyNowDialog,
    'trip-summary': TripSummary,
    'inventory-item': InventoryItem,
    'stripe': Stripe,
    'country-select': CountrySelect
  },
  data () {
    return {
      loading: true,
      trips: [],
      tripsPerPage: 20,
      tripsNextPage: 1,
      tripsLoadingMore: true,

      //orders: {},

      userHasSavedCard: (this.$store.getters.user.cc_brand ? true: false),
      billing_street: this.$store.getters.user.billing_address,
      billing_city: this.$store.getters.user.billing_city,
      billing_state: this.$store.getters.user.billing_state,
      billing_zip: this.$store.getters.user.billing_zip,
      billing_country: this.$store.getters.user.billing_country,

      buyNowDialog: false,
      buyNowTrip: null,
      buyNowSelection: null,

      buyInventory: {},
      buyTrip: {},
      buyLookbook: {},
      buyOrder: {},
      buying: false,
      buyThankYouDialog: false,

      stripeComplete: false,
    }
  },
  mounted: function() {
    this.getDataFromApi();
    //this.getOrdersFromApi();
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    currentTrips: function() {
      let tripArr = [];
      for(let i = 0; i < this.trips.length; i++) {
        let trip = this.trips[i];
        if( this.$moment(trip.checkin_date).isSameOrBefore(this.$moment(), 'day') && this.$moment(trip.checkout_date).isSameOrAfter(this.$moment(), 'day') ) 
        {
          tripArr.push(trip);
        }
      }
      return tripArr;
    },
    upcomingTrips: function() {
      let tripArr = [];
      for(let i = 0; i < this.trips.length; i++) {
        let trip = this.trips[i];
        if( this.$moment(trip.checkin_date).isAfter(this.$moment(), 'day') ) {
          tripArr.push(trip);
        }
      }
      return tripArr.sort( (a, b) => {
        if(a.checkin_date < b.checkin_date) return -1;
        if(a.checkin_date == b.checkin_date) return 0;
        if(a.checkin_date > b.checkin_date) return 1;
      })
    },
    recentTrips: function() {
      let tripArr = [];
      let cutoffDate = this.$moment().subtract(6, 'months');

      for(let i = 0; i < this.trips.length; i++) {
        let trip = this.trips[i];
        if( this.$moment(trip.checkout_date).isBefore(this.$moment(), 'day') && this.$moment(trip.checkout_date).isSameOrAfter(cutoffDate, 'day') ) {
          tripArr.push(trip);
        }
      }
      return tripArr;
    },
    pastTrips: function() {
      let tripArr = [];
      let cutoffDate = this.$moment().subtract(6, 'months');

      for(let i = 0; i < this.trips.length; i++) {
        let trip = this.trips[i];
        if( this.$moment(trip.checkout_date).isBefore(cutoffDate, 'day') ) {
          tripArr.push(trip);
        }
      }
      return tripArr;
    },

    checkoutConfirmDisabled: function() {
      if(!this.billing_street || !this.billing_city || !this.billing_state || !this.billing_zip || !this.billing_country) return true;
      if(!this.userHasSavedCard && !this.stripeComplete) return true;
      return false;
    }
  },
  methods: {
    getDataFromApi: function() {
      this.tripsLoadingMore = true;
      let params = [];
      params.push('f[user_id]=' + this.user.id);
      params.push('f[canceled_at][null]=');
      params.push('per-page=' + this.tripsPerPage);
      params.push('page=' + this.tripsNextPage);
      params.push('sort=-checkin_date');
      params.push('expand=lookbook,order,order.orderInventory,order.orderInventory.purchaseOrder,order.inventory,order.inventory.variations');

      this.$http.get('trips?' + params.join('&'))
        .then(response => {
          this.loading = false;
          this.tripsLoadingMore = false;
          if(response.data._links.next) {
            this.tripsNextPage = (response.data._meta.currentPage + 1);
          } else {
            this.tripsNextPage = 1;
          }
          this.trips = response.data.items;
        })
        .catch(error => {
					
        });
      
    },

    buyNowCompleted: function() {
      this.buyNowDialog = false;
      this.getDataFromApi();
      this.$swal.fire('Thank you for your purchase!');
    },

    findOrderByTrip: function(trip) {
      if(!trip.lookbook) return null;
      if(!trip.lookbook.order_id) return {};
      //if(!this.orders[ trip.lookbook.order_id ]) return null;
      //return this.orders[ trip.lookbook.order_id ];
    },

    removeTrip: function(id) {
      for(let i = 0; i < this.trips.length; i++) {
        if(this.trips[i].id == id) {
          this.trips.splice(i, 1);
          break;
        }
      }
    },

    openBuyNow: function(data) {
      this.buyNowTrip = data.trip;
      this.buyNowSelection = data.inventory;
      this.buyNowDialog = true;
    },

    openOwned: function(data) {
      this.buyInventory = data.inventory;
      this.buyTrip = data.trip;
      this.buyLookbook = data.lookbook;
      this.buyOrder = data.order;
      this.buyThankYouDialog = true;
    },

    updateCountry: function(val) {
      this.billing_country = val;
    },

    stripeChange: function(e) {
      this.stripeComplete = (e.complete ? true : false);
    },

    preProcessOrder: function() {
      this.buying = true;

      if(this.userHasSavedCard) {
        this.processExistingStripeCardOrder();
        return;
      }

      let data = {
        billing_address: this.billing_street,
        billing_city: this.billing_city,
        billing_state: this.billing_state,
        billing_zip: this.billing_zip,
        billing_country: this.billing_country
      }

      this.$http.patch('users/' + this.user._id, data)
        .then(response => {
          this.processNewStripeCardOrder();
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error updating your billing address');
          this.buying = false;
        })
    },

    
    processNewStripeCardOrder: function() {
      this.$refs.stripe.getToken();
    },
    processNewStripeToken: function(token) {
      let token_id = token.id;

      if(this.user.cc_brand) {

        this.$http.post('update-card', {
          user_id: this.user._id,
          cc_source: token_id
        }).then(response => {
          this.processExistingStripeCardOrder();
        }).catch(error => {
          this.$swal.fire('Error', 'There was an error updating your card');
          this.buying = false;
        })

        return;
      }

      let data = {
        user_id: this.user._id,
        trip_id: this.buyTrip._id,
        lookbook_id: this.buyLookbook._id,
        items: [ this.buyInventory._id ],
        total_price: this.buyInventory.item_tp_purchase_price,
        total_items: 1,
        ord_type: 'buy',
        cc_source: token_id
      }

      this.$http.post('charge', data)
        .then(response => {
          //this.completedOrder = response.data;
          this.buyDialog = false;
          this.buying = false;
          this.buyOrder = response.data;
          this.buyThankYouDialog = true;

          //this.$set(this.orders, response.data._id, response.data);

          this.$http.get('users/' + this.user._id)
            .then(usResponse => {
              this.$store.commit('setUser', usResponse.data);
            })
            .catch(usError => {});
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error processing your order');
          this.buying = false;
        });
    },
    processNewStripeError: function(msg) {
      this.$swal.fire('Credit Card Error', msg);
      this.buying = false;
    },

    processExistingStripeCardOrder: function() {
      let data = {
        user_id: this.user._id,
        trip_id: this.buyTrip._id,
        lookbook_id: this.buyLookbook._id,
        items: [ this.buyInventory._id ],
        total_price: this.buyInventory.item_tp_purchase_price,
        total_items: 1,
        ord_type: 'buy'
      }

      this.$http.post('charge', data)
        .then(response => {
          this.buyDialog = false;
          this.buying = false;
          this.buyOrder = response.data;
          this.buyThankYouDialog = true;

          //this.$set(this.orders, response.data._id, response.data);

          this.$http.get('users/' + this.user._id)
            .then(usResponse => {
              this.$store.commit('setUser', usResponse.data);
            })
            .catch(usError => {});
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error processing your order');
          this.ordering = false;
        });
    },

  }
}
</script>

<style lang="scss">
  .order-details-table {
    width: 100%;
    th,td {
      padding: 10px;
      text-align: center;
    }
    th {
      border: 1px solid #000;
      border-left-width: 0px;
      &:first-child {
        border-left-width: 1px;
      }
    }
    td {
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
      &:first-child {
        border-left: 1px solid #000;
      }
    }

  }

</style>
